// extracted by mini-css-extract-plugin
export default {"container_body":"search_container_body__cFM8+","loader_wrapper":"search_loader_wrapper__SR2fh"};